import { GeneralService } from 'src/app/services/general.service';
import { Credentials } from './../entity/models/credentials';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { FormFormuleService } from '../views/adm/service/form-formule.service';

@Injectable({
    providedIn: 'root'
})

export class AuthService {

    private credentials: Credentials;

    constructor(protected httpClient: HttpClient, 
        protected router: Router, 
        protected generalService: GeneralService,
        private formFormuleService: FormFormuleService) { }

    public get credencial(): Credentials {
        if (this.credentials != null) {
            return this.credentials;

        } else if (this.credentials == null && localStorage.getItem('userAuth') != null) {
            this.credentials = JSON.parse(localStorage.getItem('userAuth')) as Credentials;
            return this.credentials;
        }
        return new Credentials();
    }

    public get UserName(): string {
        if (this.credentials != null) {
            return '';

        } else if (this.credentials == null && localStorage.getItem('userAuth') != null) {
            this.credentials = JSON.parse(localStorage.getItem('userAuth')) as Credentials;
            return this.credentials?.displayName;
        }
        return '';
    }

    public Login(credencial: Credentials): Observable<Credentials> {
        // tslint:disable-next-line: max-line-length
        return this.httpClient.post<Credentials>(`${environment.api}v1/login`, { cwid: credencial.cwid, password: credencial.password }, { headers: this.getOptions() });
    }

    public keepUser(accessToken: string): void {        
        const payload = this.getTokenData(accessToken);
        this.credentials = new Credentials();
        this.credentials.cwid = payload.cwid;
        this.credentials.userName = payload.userName;
        this.credentials.displayName = payload.displayName;
        this.credentials.password = '';
        sessionStorage.setItem('userAuth', JSON.stringify(this.credentials));
    }

    public keepUserData(credencial: Credentials) {
        this.credentials = new Credentials();
        this.credentials.cwid = credencial.cwid;
        this.credentials.userName = credencial.userName;
        this.credentials.displayName = credencial.displayName;
        this.credentials.password = '';
        this.credentials.token = credencial.token;
        sessionStorage.setItem('userAuth', JSON.stringify(this.credentials));
    }

    public getTokenData(accessToken: string): any {
        if (accessToken != null) {
            return JSON.parse(this.generalService.b64DecodeUnicode(accessToken.split('.')[1]));
        }
        return null;
    }

    public isAuthenticated(): boolean {
        const payload = this.getTokenData(this.credencial.token);
        if (payload !== null && payload !== undefined) {
            return true;
        }
        return false;
    }

    public logout(): void {
        this.credentials = new Credentials();
        localStorage.removeItem('userAuth');
        this.router.navigate(['/login']);
    }

    private getOptions(): HttpHeaders {
        const headers = new HttpHeaders()
            .set('content-type', 'application/json')
            .set('Access-Control-Allow-Origin', '*')
            .set('Authorization', `Bearer ${this.getCookie()}`);
        return headers;
    }

    private getCookie(): string {
        const name = 'frontend-app=';
        const ca = document.cookie.split(';');
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length).trim();
            }
        }
        return '';
    }    
}